import React, { useState } from "react";
import { ConfigProvider, Layout, Menu } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  HomeOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  CaretRightOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileJpgOutlined,
  UploadOutlined,
  FileTextOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

import logo from "../assets/logo-text.png";

const { Header, Sider, Content } = Layout;

function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const logoutClicked = () => {
    //TODO: api call for token cancellation
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.clear();
    navigate("/");
  };

  const isAllowed = (allowedRoles) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let userRole = user ? user.role : null;
    let isAllowed = false;
    if (userRole) {
      isAllowed = allowedRoles.find((role) => role === userRole);
    }
    return isAllowed;
  };

  const items = [
    {
      label: "Dashboard",
      path: "dashboard",
      key: "dashboard",
      icon: <HomeOutlined />,
    },
    {
      label: "Students",
      path: "students",
      key: "students",
      icon: <UserOutlined />,
    },
    {
      label: "Students Payment",
      path: "students-payment",
      key: "students-payment",
      icon: <UserOutlined />,
    },
    {
      label: "Result",
      path: "result",
      key: "result",
      icon: <FileDoneOutlined />,
    },
    {
      label: "Tests",
      path: "tests",
      key: "tests",
      permission: ["admin"],
      icon: <FileTextOutlined />,
    },
    {
      label: "Notes",
      path: "notes",
      key: "notes",
      icon: <CaretRightOutlined />,
    },
    {
      label: "Videos",
      path: "videos",
      key: "videos",
      icon: <CaretRightOutlined />,
    },
    {
      label: "Daily Content",
      path: "daily-content",
      key: "daily-content",
    },
    {
      label: "Notices",
      path: "notices",
      key: "notices",
    },
    {
      label: "Social Links",
      path: "links",
      key: "links",
    },
    {
      label: "Pharma News",
      path: "pharma",
      key: "pharma",
    },
    {
      label: "Student Review",
      path: "student-review",
      key: "student-review",
    },
    {
      label: "Collabaration",
      path: "collabaration",
      key: "collabaration",
    },
    {
      label: "Achievement",
      path: "achievement",
      key: "achievement",
    },
    {
      label: "Job Update",
      path: "job-update",
      key: "job-update",
    },
    {
      label: "Settings",
      key: "Settings",
      icon: <SettingOutlined />,
      permission: ["admin"],
      children: [
        {
          label: "Subjects",
          path: "setting/subjects",
          key: "subjects",
          icon: <CaretRightOutlined />,
        },
        {
          label: "Subscription Types",
          path: "setting/subscription-types",
          key: "subscription-types",
          icon: <CaretRightOutlined />,
        },
      ],
    },
    {
      label: "Log Out",
      key: "logout",
      icon: <LogoutOutlined />,
      onClick: logoutClicked,
    },
  ];

  let href = window.location.href?.split("/");
  href = href.slice(-1);

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed} theme="light">
        <div className="logo">
          <img
            style={{ height: 50, width: "100%" }}
            src={logo}
            alt="GPAT Academy"
          />
        </div>
        <ConfigProvider
          theme={{
            token: {
              fontSize: 14,
              itemBorderRadius: 16,
            },
          }}
        >
          <Menu
            theme="light"
            mode="inline"
            defaultSelectedKeys={href}
            selectedKeys={href}
            items={items.map((l1_item, index) => {
              let return_status = 0;
              if (l1_item?.permission) {
                if (isAllowed(l1_item?.permission)) {
                  return_status = 1;
                }
              } else {
                return_status = 1;
              }
              return (
                return_status && {
                  ...l1_item,
                  label: l1_item?.path ? (
                    <Link to={l1_item?.path}>{l1_item?.label}</Link>
                  ) : (
                    <>{l1_item?.label}</>
                  ),
                  children: l1_item?.children?.map((l2_item, l2_index) => {
                    let return_status = 0;
                    if (l2_item?.permission) {
                      if (isAllowed(l2_item?.permission)) {
                        return_status = 1;
                      }
                    } else {
                      return_status = 1;
                    }
                    return (
                      return_status && {
                        ...l2_item,
                        label: <Link to={l2_item?.path}>{l2_item?.label}</Link>,
                      }
                    );
                  }),
                }
              );
            })}
          ></Menu>
        </ConfigProvider>
      </Sider>
      <Layout
        className="site-layout"
        style={{
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <Header style={{ padding: 0 }}>
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: toggle,
            }
          )}
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 5,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default MainLayout;
